var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{'CustomPopup':_vm.showCustomPopup},on:{"click":_vm.maskClick}}),_c('div',{staticClass:"CustomPopupContent",class:{'CustomPopupContentShow':_vm.showCustomPopup}},[_vm._t("PoperContent")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }